/**
 * delete_business_controller.js — Settings > Danger Zone: the owner deletes the business (Stimulus).
 *
 * The dialog's Delete button stays disabled until the business name is typed
 * exactly. The server refuses a non-owner and a business other people still
 * work in (application/services/business_closure.py); its sentence shows in the
 * dialog. On success the page leaves with a full load to the account page: the
 * session no longer has a business, and the POST itself crossed the service
 * worker's session boundary, which wiped this business's cached pages.
 *
 * Wiring (templates/settings.html):
 *   data-controller="delete-business"
 *   data-delete-url, data-business-name   on the controller element
 *   targets: dialog, nameInput, confirmButton, error
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["dialog", "nameInput", "confirmButton", "error"];

    open() {
        this.nameInputTarget.value = "";
        this._showError("");
        this.match();
        bootstrap.Modal.getOrCreateInstance(this.dialogTarget).show();
    }

    /** Enable Delete only while the typed name is the business's name. */
    match() {
        const typed = this.nameInputTarget.value.trim();
        this.confirmButtonTarget.disabled = !typed || typed !== this.element.dataset.businessName;
    }

    async confirm() {
        this.confirmButtonTarget.disabled = true;
        this._showError("");
        try {
            const data = await window.api(this.element.dataset.deleteUrl, { method: "POST", notifyError: false });
            window.location.href = data.redirect_url;
        } catch (error) {
            this._showError((error.data && error.data.message) || "Could not delete the business. Please try again.");
            this.match();
        }
    }

    _showError(message) {
        this.errorTarget.textContent = message;
        this.errorTarget.hidden = !message;
    }
}
